import React, { createContext, useContext, useMemo, useState } from 'react';
import generatedPhraseTranslations from './laborPortalGeneratedTranslations';
import saFlag from '../../assets/flags/sa.svg';
import gbFlag from '../../assets/flags/gb.svg';
import pkFlag from '../../assets/flags/pk.svg';
import bdFlag from '../../assets/flags/bd.svg';
import idFlag from '../../assets/flags/id.svg';
import inFlag from '../../assets/flags/in.svg';
import phFlag from '../../assets/flags/ph.svg';

export const LABOR_PORTAL_LANGUAGE_KEY = 'wazin_labor_portal_language';

export const laborPortalLanguages = [
  { code: 'ar', label: 'العربية', flag: saFlag, flagAlt: 'علم المملكة العربية السعودية', dir: 'rtl', locale: 'ar-SA' },
  { code: 'en', label: 'English', flag: gbFlag, flagAlt: 'United Kingdom flag', dir: 'ltr', locale: 'en-GB' },
  { code: 'ur', label: 'اردو', flag: pkFlag, flagAlt: 'پاکستان کا پرچم', dir: 'rtl', locale: 'ur-PK' },
  { code: 'bn', label: 'বাংলা', flag: bdFlag, flagAlt: 'বাংলাদেশের পতাকা', dir: 'ltr', locale: 'bn-BD' },
  { code: 'id', label: 'Bahasa Indonesia', flag: idFlag, flagAlt: 'Bendera Indonesia', dir: 'ltr', locale: 'id-ID' },
  { code: 'ml', label: 'മലയാളം', flag: inFlag, flagAlt: 'ഇന്ത്യയുടെ പതാക', dir: 'ltr', locale: 'ml-IN' },
  { code: 'tl', label: 'Tagalog', flag: phFlag, flagAlt: 'Watawat ng Pilipinas', dir: 'ltr', locale: 'fil-PH' },
];

const phraseTranslations = {
  'Wazin Labor Portal': {
    ur: 'وازن لیبر پورٹل',
    bn: 'ওয়াজিন শ্রম মামলা পোর্টাল',
    id: 'Portal Ketenagakerjaan Wazin',
    ml: 'വാസിൻ തൊഴിൽ പോർട്ടൽ',
    tl: 'Wazin Labor Portal',
  },
  'Labor Cases Portal': {
    ur: 'لیبر مقدمات کا پورٹل',
    bn: 'শ্রম মামলা পোর্টাল',
    id: 'Portal Perkara Ketenagakerjaan',
    ml: 'തൊഴിൽ കേസുകളുടെ പോർട്ടൽ',
    tl: 'Portal ng mga Kaso sa Paggawa',
  },
  'A page dedicated to submitting information and documents': {
    ur: 'معلومات اور دستاویزات جمع کرانے کے لیے مخصوص صفحہ',
    bn: 'তথ্য ও নথি জমা দেওয়ার জন্য নির্ধারিত পৃষ্ঠা',
    id: 'Halaman khusus untuk mengirim data dan dokumen',
    ml: 'വിവരങ്ങളും രേഖകളും സമർപ്പിക്കുന്നതിനുള്ള പ്രത്യേക പേജ്',
    tl: 'Pahinang nakalaan sa pagsusumite ng impormasyon at mga dokumento',
  },
  'Wazin platform is being launched gradually.': {
    ur: 'وازن پلیٹ فارم مرحلہ وار شروع کیا جا رہا ہے۔',
    bn: 'ওয়াজিন প্ল্যাটফর্ম ধাপে ধাপে চালু করা হচ্ছে।',
    id: 'Platform Wazin diluncurkan secara bertahap.',
    ml: 'വാസിൻ പ്ലാറ്റ്ഫോം ഘട്ടംഘട്ടമായി ആരംഭിക്കുന്നു.',
    tl: 'Unti-unting inilulunsad ang Wazin platform.',
  },
  'Previous': { ur: 'پچھلا', bn: 'পূর্ববর্তী', id: 'Sebelumnya' },
  'Next': { ur: 'اگلا', bn: 'পরবর্তী', id: 'Berikutnya' },
  'Save as Draft': { ur: 'مسودہ محفوظ کریں', bn: 'খসড়া হিসেবে সংরক্ষণ করুন', id: 'Simpan sebagai Draf' },
  'Submit Request': { ur: 'درخواست جمع کریں', bn: 'আবেদন জমা দিন', id: 'Kirim Permohonan' },
  'Submitting...': { ur: 'جمع کیا جا رہا ہے...', bn: 'জমা দেওয়া হচ্ছে...', id: 'Mengirim...' },
  'Choose file': { ur: 'فائل منتخب کریں', bn: 'ফাইল নির্বাচন করুন', id: 'Pilih berkas' },
  'Remove': { ur: 'حذف کریں', bn: 'মুছুন', id: 'Hapus' },
  'Yes': { ur: 'ہاں', bn: 'হ্যাঁ', id: 'Ya' },
  'No': { ur: 'نہیں', bn: 'না', id: 'Tidak' },
  'Not sure': { ur: 'معلوم نہیں', bn: 'জানি না', id: 'Tidak tahu' },
  'Other': { ur: 'دیگر', bn: 'অন্যান্য', id: 'Lainnya' },
  'New': { ur: 'نیا', bn: 'নতুন', id: 'Baru' },
  'Under review': { ur: 'زیرِ جائزہ', bn: 'পর্যালোচনাধীন', id: 'Sedang ditinjau' },
  'Completed': { ur: 'مکمل', bn: 'সম্পন্ন', id: 'Selesai' },
  'Waiting for client': { ur: 'کلائنٹ کے جواب کا انتظار', bn: 'ক্লায়েন্টের অপেক্ষায়', id: 'Menunggu klien' },
  'Waiting for missing items': {
    ur: 'درکار معلومات یا دستاویزات کا انتظار',
    bn: 'অসম্পূর্ণ তথ্য বা নথির অপেক্ষায়',
    id: 'Menunggu kelengkapan',
  },
  'Missing items completed': {
    ur: 'درکار معلومات مکمل کر دی گئی ہیں',
    bn: 'অসম্পূর্ণ তথ্য পূরণ করা হয়েছে',
    id: 'Kelengkapan telah dikirim',
  },
  'Waiting for completed items review': {
    ur: 'جمع شدہ تکمیل کے جائزے کا انتظار',
    bn: 'জমা দেওয়া তথ্য পর্যালোচনার অপেক্ষায়',
    id: 'Menunggu peninjauan kelengkapan',
  },
  'Reference Number': { ur: 'حوالہ نمبر', bn: 'রেফারেন্স নম্বর', id: 'Nomor Referensi' },
  'Mobile Number': { ur: 'موبائل نمبر', bn: 'মোবাইল নম্বর', id: 'Nomor Ponsel' },
  'Tracking Code': { ur: 'ٹریکنگ کوڈ', bn: 'ট্র্যাকিং কোড', id: 'Kode Pelacakan' },
  'Track Request': { ur: 'درخواست دیکھیں', bn: 'আবেদন অনুসরণ করুন', id: 'Lacak Permohonan' },
  'Client Details': { ur: 'کلائنٹ کی معلومات', bn: 'ক্লায়েন্টের তথ্য', id: 'Data Klien' },
  'Employer Details': { ur: 'ادارے کی معلومات', bn: 'প্রতিষ্ঠানের তথ্য', id: 'Data Pemberi Kerja' },
  'Contract and Relationship': { ur: 'معاہدہ اور ملازمت کا تعلق', bn: 'চুক্তি ও কর্মসম্পর্ক', id: 'Kontrak dan Hubungan Kerja' },
  'Employment Relationship, Wage, and Entitlements Analysis': {
    ur: 'ملازمت، اجرت اور واجبات',
    bn: 'কর্মসম্পর্ক, মজুরি ও পাওনা',
    id: 'Hubungan Kerja, Upah, dan Hak',
  },
  'Termination and Claims': { ur: 'ملازمت کا اختتام اور مطالبات', bn: 'চাকরির সমাপ্তি ও দাবি', id: 'Berakhirnya Hubungan dan Tuntutan' },
  'Summary of Data and Facts': { ur: 'معلومات اور حقائق کا خلاصہ', bn: 'তথ্য ও ঘটনার সারসংক্ষেপ', id: 'Ringkasan Data dan Fakta' },
  'Attachments': { ur: 'منسلکات', bn: 'সংযুক্তি', id: 'Lampiran' },
  'Final Declaration and Submission': { ur: 'حتمی اقرار اور ارسال', bn: 'চূড়ান্ত ঘোষণা ও জমা', id: 'Pernyataan Akhir dan Pengiriman' },
};

const LaborPortalLanguageContext = createContext(null);

const getInitialLanguage = () => {
  if (typeof window === 'undefined') return 'ar';
  const saved = window.localStorage.getItem(LABOR_PORTAL_LANGUAGE_KEY);
  return laborPortalLanguages.some((language) => language.code === saved) ? saved : 'ar';
};

export const LaborPortalLanguageProvider = ({ children }) => {
  const [language, setLanguageState] = useState(getInitialLanguage);
  const languageConfig = laborPortalLanguages.find((item) => item.code === language) || laborPortalLanguages[0];

  const setLanguage = (nextLanguage) => {
    if (!laborPortalLanguages.some((item) => item.code === nextLanguage)) return;
    setLanguageState(nextLanguage);
    window.localStorage.setItem(LABOR_PORTAL_LANGUAGE_KEY, nextLanguage);
  };

  const value = useMemo(() => {
    const text = (arabicText, englishText) => {
      if (language === 'ar') return arabicText;
      if (language === 'en') return englishText;
      return phraseTranslations[englishText]?.[language]
        || generatedPhraseTranslations[englishText]?.[language]
        || englishText;
    };

    return {
      language,
      setLanguage,
      languageConfig,
      languages: laborPortalLanguages,
      isArabic: language === 'ar',
      isRtl: languageConfig.dir === 'rtl',
      text,
    };
  }, [language, languageConfig]);

  return (
    <LaborPortalLanguageContext.Provider value={value}>
      {children}
    </LaborPortalLanguageContext.Provider>
  );
};

export const useLaborPortalLanguage = () => {
  const context = useContext(LaborPortalLanguageContext);
  if (!context) {
    throw new Error('useLaborPortalLanguage must be used inside LaborPortalLanguageProvider');
  }
  return context;
};
